<div
  class="section-container"
  [ngClass]="{
    'has-subsection': section.children && section.children.length > 0,
  }"
>
  <div
    class="section"
    [ngClass]="{ selected: isSelected(section) }"
    (click)="onSectionClick(section.id)"
  >
    <hyperkit-typography
      class="section-title"
      variant="label1"
      align="left"
      color="primary"
      >{{ section.title }}</hyperkit-typography
    >
    <!-- <hyperkit-icon
      *ngIf="!section.children && section.status"
      [icon]="getStatusIcon(section.status)"
      size="small"
      color="primary"
      class="status-icon"
    >
    </hyperkit-icon> -->
  </div>

  <div
    class="subsections"
    *ngIf="section.children && section.children.length > 0"
  >
    <div *ngFor="let child of section.children" class="subsection-item">
      <div
        class="subsection"
        [ngClass]="{ selected: isSelected(child) }"
        (click)="onSectionClick(child.id)"
      >
        <hyperkit-typography
          class="subsection-title"
          variant="label1"
          align="left"
          color="primary"
          >{{ child.title }}</hyperkit-typography
        >
        <!-- <hyperkit-icon 
          *ngIf="child.status"
          [icon]="getStatusIcon(child.status)"
          size="small"
          color="primary"
          class="status-icon">
        </hyperkit-icon> -->
      </div>
    </div>
  </div>
</div>
